import type { Volume } from '../types/product';

export const volumes: Volume[] = [
  {
    label: 'TOMO I',
    theme: 'green',
    title: 'Il Manuale Pratico della Consulenza Floreale',
    summary: 'Un percorso chiaro, dall’apertura dell’incontro alla chiusura.',
    cover: 'https://cdn.magicpatterns.com/uploads/eYaYY5NJEJb5jCyVNSoQym/Portada_botanica_italiana_de_flores_de_Bach-1.png',
    coverAlt: 'Copertina del Tomo I: Il Manuale Pratico della Consulenza Floreale',
    features: [
      'Un metodo chiaro dall’ascolto al follow-up.',
      'Domande utili e confronti tra fiori simili.',
      '10 schede pratiche e 5 casi didattici.',
      'Strumenti per spiegare le scelte, registrare e chiudere ogni incontro.',
      '50 pagine pronte da consultare.',
    ],
  },
  {
    label: 'TOMO II',
    theme: 'rose',
    title: '15 Combinazioni Floreali da Personalizzare',
    summary: 'Esempi ragionati per partire da un criterio e adattarlo alla persona.',
    cover: 'https://cdn.magicpatterns.com/uploads/7VuTJAw5i8j9JauYq25ECf/Combinaciones_florales_y_botellas_ambar-2.png',
    coverAlt: 'Copertina del Tomo II: 15 Combinazioni Floreali da Personalizzare',
    features: [
      '15 combinazioni floreali da studiare e personalizzare.',
      'Criteri, domande e alternative per motivare ogni scelta.',
      'Esempi su timori, cambiamenti, fiducia e relazioni.',
      '3 combinazioni dedicate all’operatore, casi didattici e schede di follow-up.',
      '50 pagine pronte da consultare.',
    ],
    note: 'Una guida per motivare le scelte, senza applicare la stessa combinazione a tutti.',
  },
];
